import React from "react";
import { Helmet } from "react-helmet-async";

const Team = () => {
  const teamMembers = [
    {
      id: 1,
      name: "रवि शर्मा",
      role: "संस्थापक और प्रधान संपादक",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400&h=500",
      socials: { twitter: "#", linkedin: "#" }
    },
    {
      id: 2,
      name: "अदिति वर्मा",
      role: "प्रबंध संपादक",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400&h=500",
      socials: { twitter: "#", linkedin: "#" }
    },
    {
      id: 3,
      name: "विक्रम सिंह",
      role: "वरिष्ठ राजनीतिक संवाददाता",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=400&h=500",
      socials: { twitter: "#", linkedin: "#" }
    },
    {
      id: 4,
      name: "प्रिया पटेल",
      role: "संस्कृति और कला रिपोर्टर",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=400&h=500",
      socials: { twitter: "#", linkedin: "#" }
    },
    {
      id: 5,
      name: "आनंद कुमार",
      role: "तकनीक और व्यापार विश्लेषक",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=400&h=500",
      socials: { twitter: "#", linkedin: "#" }
    },
    {
      id: 6,
      name: "नेहा गुप्ता",
      role: "फोटो जर्नलिस्ट",
      image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=400&h=500",
      socials: { twitter: "#", linkedin: "#" }
    },
    {
      id: 7,
      name: "रमेश तिवारी",
      role: "स्थानीय समाचार रिपोर्टर",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=400&h=500",
      socials: { twitter: "#", linkedin: "#" }
    },
    {
      id: 8,
      name: "सान्या मिश्रा",
      role: "डिजिटल कंटेंट प्रमुख",
      image: "https://images.unsplash.com/photo-1598550874175-4d0ef43ce5bb?auto=format&fit=crop&q=80&w=400&h=500",
      socials: { twitter: "#", linkedin: "#" }
    }
  ];

  return (
    <div className="bg-[#f8f9fa] min-h-screen pb-20">
      <Helmet>
        <title>हमारी टीम | द मंदाकिनी टाइम्स</title>
        <meta name="description" content="द मंदाकिनी टाइम्स के पीछे के पत्रकारों और संपादकों से मिलें।" />
      </Helmet>

      {/* Hero Section */}
      <div className="bg-brand-purple text-white py-16 px-4 mb-16 relative overflow-hidden">
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-white opacity-10 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 rounded-full bg-white opacity-10 blur-3xl"></div>
        <div className="max-w-7xl mx-auto relative z-10 text-center">
          <h1 className="text-4xl md:text-5xl font-black tracking-tight mb-4 drop-shadow-md">
            हमारी <span className="text-purple-200">टीम</span>
          </h1>
          <p className="text-red-100 text-lg font-medium max-w-2xl mx-auto">
            सच्चाई, साहस और निष्पक्ष पत्रकारिता के प्रति समर्पित हमारे लोग।
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-20">
        
        {/* Modern Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member) => (
            <div 
              key={member.id} 
              className="group relative rounded-2xl overflow-hidden bg-gray-200 shadow-sm hover:shadow-2xl transition-all duration-500 cursor-pointer h-[420px]"
            >
              {/* Image */}
              <img 
                src={member.image} 
                alt={member.name} 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-in-out"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300"></div>

              {/* Content Box (Name & Role) */}
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                <h3 className="text-2xl font-bold text-white mb-1">
                  {member.name}
                </h3>
                <p className="text-purple-400 font-medium text-sm mb-2">
                  {member.role}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Team;
